import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=56ab7938&scoped=true&"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js&"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=56ab7938&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab7938",
  null
  
)

export default component.exports